import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0073',
    ecrans: ['00-2']
});
